import type { LeaderboardData } from '../components/Leaderboard';
import type { BrandStatsData } from '../components/BrandStats';

/**
 * Realistic-looking sample data for /demo. Shaped to mirror what the live
 * MCP tools `list_top_brands_in_project` and `get_brand_stats` actually
 * return — same field names, same value ranges. If we ever change the live
 * tool shape, the demo will look wrong, which is the right signal.
 */

export const sampleLeaderboard: LeaderboardData = {
  scope_label: 'Project: AI Code Quality Q4',
  from: '2026-05-10T00:00:00.000Z',
  to: '2026-05-17T23:59:59.999Z',
  highlight_brand_id: 'brn_42a',
  items: [
    { brand_id: 'brn_athena', name: 'Athena', mention_count: 1842 },
    { brand_id: 'brn_42a', name: '42a', mention_count: 1576 },
    { brand_id: 'brn_profound', name: 'Profound', mention_count: 1391 },
    { brand_id: 'brn_otterly', name: 'Otterly', mention_count: 1208 },
    { brand_id: 'brn_brandlux', name: 'BrandLux', mention_count: 943 },
    { brand_id: 'brn_mentionhq', name: 'MentionHQ', mention_count: 812 },
    { brand_id: 'brn_searchlight', name: 'Searchlight', mention_count: 657 },
    { brand_id: 'brn_visora', name: 'Visora AI', mention_count: 504 },
    { brand_id: 'brn_signalpath', name: 'SignalPath', mention_count: 412 },
    { brand_id: 'brn_pulsemark', name: 'Pulsemark', mention_count: 339 },
  ],
};

export const sampleBrandStats: BrandStatsData = {
  brand_id: 'brn_42a',
  brand_name: '42a',
  from: '2026-05-10T00:00:00.000Z',
  to: '2026-05-17T23:59:59.999Z',
  visibility_score: 0.47,
  mention_count: 1576,
  mention_coverage: 0.62,
  avg_position: 2.8,
  sentiment_score: 0.34,
  trend: {
    score_change: 0.08,
    mention_change: 184,
    position_change: -0.4,
  },
  history: [
    { date: '2026-05-10', visibility_score: 0.38, mention_count: 198 },
    { date: '2026-05-11', visibility_score: 0.41, mention_count: 216 },
    { date: '2026-05-12', visibility_score: 0.43, mention_count: 224 },
    { date: '2026-05-13', visibility_score: 0.45, mention_count: 232 },
    { date: '2026-05-14', visibility_score: 0.46, mention_count: 230 },
    { date: '2026-05-15', visibility_score: 0.49, mention_count: 241 },
    { date: '2026-05-16', visibility_score: 0.51, mention_count: 235 },
  ],
};
